module.exports = __webpack_public_path__ + "img/4_x4.f8f87dbd.png";